import { __awaiter } from "tslib";
import s3 from '@/requests/s3';
import { showError } from '@/store';
import { defineComponent, reactive, watch, onMounted, ref } from '@vue/composition-api';
export default defineComponent({
    props: {
        src: {},
        fullSrc: {
            default: null
        },
        fullImage: {
            default: true
        },
        upload: {
            default: true
        },
        height: {
            default: '140px'
        },
        size: {
            default: 640
        },
        path: {
            default: ''
        },
        quality: {
            default: 0.8
        }
    },
    setup($p, context) {
        // ================
        //
        // refs
        //
        let image = ref(null);
        // ================
        //
        // state
        //
        let $ = reactive({
            fullSrc: null,
            targetSrc: null,
            fullImage: false,
            imageLoading: false
        });
        // ================
        //
        // watch
        //
        watch(() => $p.src, () => loadImg());
        // ================
        //
        // mounted
        //
        onMounted(() => {
            loadImg();
        });
        // ================
        //
        // methods
        //
        let viewFullImage = () => {
            $.fullImage = true;
        };
        let imageError = () => {
            $.targetSrc = null;
        };
        let loadImg = () => {
            setTimeout(() => __awaiter(this, void 0, void 0, function* () {
                if ($p.fullSrc) {
                    $.fullSrc = yield s3.getImage($p.fullSrc);
                }
                if ($p.src) {
                    $.targetSrc = yield s3.getImage($p.src);
                }
                else {
                    $.targetSrc = '/images/no-image.png';
                }
            }), 100);
        };
        let uploadImage = () => __awaiter(this, void 0, void 0, function* () {
            $.imageLoading = true;
            let file = image.value.files[0];
            if (file) {
                try {
                    let name = typeof $p.path === 'function' ? $p.path() : $p.path;
                    let { key } = yield s3.uploadImage({
                        file,
                        name: name,
                        width: $p.size,
                        height: $p.size,
                        quality: $p.quality
                    });
                    yield new Promise(done => setTimeout(done, 500));
                    $.targetSrc = yield s3.getImage(key);
                    context.emit('uploaded', key);
                }
                catch (error) {
                    showError(error);
                }
                image.value.value = '';
            }
            $.imageLoading = false;
        });
        return {
            $,
            image,
            imageError,
            loadImg,
            uploadImage,
            viewFullImage
        };
    }
});
